import React, { useEffect, useState } from "react";
import { useTeamContext } from "store/contexts/teamContext";
import Loader from "components//Loader";
import TeamService from "services/TeamService";
import UserDefaultAvatar from "assets/img/user.svg";
import Button from "components/CustomButton";
import { useUserContext } from "store/contexts/userContext";
import { Modal } from "react-responsive-modal";
import InviteTeamMember from "components/InviteTeamMember";
import { useToasts } from "react-toast-notifications";
import { ReactComponent as Checkbox } from "assets/img/icons/checkbox.svg";
import { ReactComponent as UnCheckBox } from "assets/img/icons/uncheckbox.svg";
import classNames from "classnames";

const styles = {
  divRoot: {
    display: "flex",
    gap: "5px",
  },
  cancelButton: {
    color: "black",
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "white",
      color: "black",
    },
  },
  dialogTitle: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: "0 0 auto",
    margin: 0,
    padding: "12px 0px 12px",
  },
  dialogHeading: {
    fontWeight: "600",
  },
  dialogContent: {
    height: "450px",
    maxHeight: "450px",
    overflow: "auto",
    flex: "1 1 auto",
    padding: "8px 24px",
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
  },
  allMember: {
    display: "flex",
    padding: "10px",
    justifyContent: "flex-end",
    borderBottom: "1px solid rgb(204, 204, 204)",
    gap: "15px",
  },
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
    borderBottom: "1px solid #ccc",
  },
  memberDetail: {
    display: "flex",
    gap: "10px",
    fontWeight: "400",
    alignItems: "center",
  },
  avatar: {
    minHeight: "30px",
    height: "30px",
    minWidth: "30px",
    width: "30px",
    borderRadius: "50%",
  },
  button: {
    background: "linear-gradient(60deg, #1176b8, #1176b8)",
    fontWeight: "500",
  },
  cursorPointer: {
    cursor: "pointer",
  },
  memberNameAll: {
    fontWeight: "bolder",
  },
  membersList: {
    position: "relative",
    marginRight: "25px",
    display: "flex",
    alignItems: "center",
  },
  noMember: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  loaderClass: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  uncheckbox: {
    width: "20px",
    height: "20px",
  },
  checkbox: {
    width: "23px",
    height: "23px",
  },
  doneButton: {
    width: "100px",
    background: "none",
    height: "unset",
    color: "#ffa100",
    boxShadow: "unset",
  },
  rightButton: {
    position: "absolute",
    top: "0",
    right: "0",
  },
};

export default ({
  children,
  setSelectedMember,
  selectedMember,
  joinWaterCooler,
  loading,
  setMemberSelectionOpen,
  post = true,
}) => {
  const classes = styles;
  const { team, setTeam } = useTeamContext();
  const [dialogState, setDialogState] = useState(false);
  const { user } = useUserContext();
  const { addToast } = useToasts();
  const [allMembersData, setAllMembers] = useState([]);
  const [selectAllTeamMember, setSelectAllTeamMember] = useState(false);

  useEffect(() => {
    if (team?.members && team.members.length) {
      return;
    }

    (async () => {
      try {
        const response = await TeamService.getMembers(team?.id);
        setTeam({
          ...team,
          members: response.data.data,
        });
      } catch (e) {}
    })();

    // eslint-disable-next-line
  }, [team?.id, setTeam]);

  useEffect(() => {
    if ((allMembersData && allMembersData.length) || !team?.members) {
      return;
    }

    setAllMembers(
      post
        ? team?.members.filter((member) => member?.id !== user?.id)
        : [...team?.members]
    );

    //eslint-disable-next-line
  }, [post, team]);

  const onMemberSelect = (member) => {
    setSelectedMember([...selectedMember, member]);
    addToast("Member is selected ", {
      appearance: "success",
    });
  };

  const discardMember = (member) => {
    setSelectedMember(
      selectedMember.filter((selectedMember) => {
        return selectedMember.id !== member.id;
      })
    );
    addToast("Member is removed ", { appearance: "error" });
  };

  const closeModal = () => {
    setSelectedMember([]);
    setDialogState(false);
    setSelectAllTeamMember(false);
    setMemberSelectionOpen(false);
  };

  const doneModal = async () => {
    await joinWaterCooler();
    setDialogState(false);
  };

  const toggleSelectTeamMember = () => {
    setSelectAllTeamMember(!selectAllTeamMember);
    setSelectedMember(!selectAllTeamMember ? [...allMembersData] : []);
    if (!selectAllTeamMember) {
      addToast("All Members are selected ", {
        appearance: "success",
      });
    } else {
      addToast("All Members are removed ", {
        appearance: "error",
      });
    }
  };

  const openModal = () => {
    setDialogState(true);
    setMemberSelectionOpen(true);
  };

  const closeModalTotally = () => {
    setDialogState(false);
    setMemberSelectionOpen(false);
  };

  return (
    <>
      <div
        className={classNames({
          noPointerEvent: loading ? true : false,
        })}
        style={{ width: "100%" }}
        onClick={openModal}
      >
        {children}
      </div>
      <Modal
        open={dialogState}
        onClose={closeModalTotally}
        closeOnEsc={false}
        closeOnOverlayClick={false}
        showCloseIcon={false}
        center={true}
        classNames={{
          modalContainer: "modalContainer",
          modal: "waterCoolerRoot",
        }}
      >
        <div className="modal fade popup-modal">
          <div className="modal-content">
            <div className="modal-body">
              <div style={classes.dialogTitle}>
                <h5 style={classes.dialogHeading}>Select Member</h5>
                {!!team?.members && allMembersData?.length > 0 && (
                  <div style={classes.rightButton}>
                    <Button
                      buttonStyle={classes.doneButton}
                      onClick={doneModal}
                      type="button"
                      name={
                        !loading ? "Done" : <Loader width={20} height={20} />
                      }
                      disabled={
                        (selectedMember.length === 0 || loading) && true
                      }
                    />
                  </div>
                )}
              </div>
              <div style={classes.dialogContent}>
                <div style={classes.listContainer}>
                  {!team?.members && (
                    <div style={classes.loaderClass}>
                      <Loader />
                    </div>
                  )}
                  {!!team?.members && (
                    <div style={classes.allMember}>
                      <div style={classes.memberDetail}>
                        <span style={classes.memberNameAll}>
                          {selectAllTeamMember ? "Deselect All" : "Select All"}
                        </span>
                      </div>
                      {!selectAllTeamMember && (
                        <UnCheckBox
                          onClick={toggleSelectTeamMember}
                          style={classes.uncheckbox}
                        />
                      )}
                      {selectAllTeamMember && (
                        <Checkbox
                          onClick={toggleSelectTeamMember}
                          style={classes.checkbox}
                        />
                      )}
                    </div>
                  )}
                  {!!allMembersData &&
                    allMembersData.map((member) =>
                      member?.id !== user?.id ? (
                        <div style={classes.listItem} key={member?.id}>
                          <div style={classes.memberDetail}>
                            <img
                              alt={`${member.avatar}`}
                              style={classes.avatar}
                              src={member.avatar ?? UserDefaultAvatar}
                            />
                            <span style={classes.memberName}>
                              {member.full_name}
                            </span>
                          </div>
                          {!selectedMember.includes(member) && (
                            <UnCheckBox
                              style={classes.uncheckbox}
                              onClick={() => {
                                if (onMemberSelect) {
                                  onMemberSelect(member);
                                  setSelectAllTeamMember(
                                    [...selectedMember, member]?.length ===
                                      allMembersData?.length
                                  );
                                }
                              }}
                            />
                          )}
                          {selectedMember.includes(member) && (
                            <Checkbox
                              style={classes.checkbox}
                              onClick={() => {
                                if (onMemberSelect) {
                                  discardMember(member);
                                  setSelectAllTeamMember(false);
                                }
                              }}
                            />
                          )}
                        </div>
                      ) : null
                    )}
                  {team?.members && allMembersData?.length === 0 && (
                    <div style={classes.noMember}>
                      <p>
                        Currently you do not have any members. Invite member
                        here.
                      </p>
                      {team?.role_id === 2 || team?.role_id === 3 ? (
                        <InviteTeamMember
                          teamName={team?.name}
                          teamId={team?.id}
                        >
                          <Button
                            style={classes.button}
                            buttonClass="invite-btn text-center"
                          >
                            Invite Members
                          </Button>
                        </InviteTeamMember>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
              <div>
                <Button
                  buttonClass="small-btn me-2"
                  onClick={closeModal}
                  disabled={loading && true}
                  style={classes.cancelButton}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
